import type { Alert, Severity } from '../types';

const MOCK_DATE = '2026-08-06T00:00:00Z';

const timeOffset = (hoursAgo: number): string => {
  const date = new Date(MOCK_DATE);
  date.setHours(date.getHours() - hoursAgo);
  return date.toISOString();
};

export const MOCK_ALERTS: Alert[] = [
  {
    id: 'alt-001',
    severity: 'critical',
    ruleName: 'Velocity Limit Exceeded',
    customerName: 'Acme Trading Co.',
    timestamp: timeOffset(1),
    status: 'open',
  },
  {
    id: 'alt-002',
    severity: 'high',
    ruleName: 'Large Transfer to High-Risk Jurisdiction',
    customerName: 'Global Freight LLC',
    timestamp: timeOffset(2),
    status: 'investigating',
  },
  {
    id: 'alt-003',
    severity: 'critical',
    ruleName: 'Structuring Detected',
    customerName: 'Metro Remittance Inc.',
    timestamp: timeOffset(3),
    status: 'open',
  },
  {
    id: 'alt-004',
    severity: 'medium',
    ruleName: 'Round-Dollar Transactions',
    customerName: 'Sunrise Logistics',
    timestamp: timeOffset(5),
    status: 'investigating',
  },
  {
    id: 'alt-005',
    severity: 'low',
    ruleName: 'New Device Login',
    customerName: 'Harbor Imports',
    timestamp: timeOffset(8),
    status: 'resolved',
  },
  {
    id: 'alt-006',
    severity: 'high',
    ruleName: 'Rapid Account Balance Change',
    customerName: 'Pacific Exports Ltd.',
    timestamp: timeOffset(9),
    status: 'open',
  },
  {
    id: 'alt-007',
    severity: 'medium',
    ruleName: 'Unexpected Weekend Activity',
    customerName: 'Northern Shipping',
    timestamp: timeOffset(12),
    status: 'investigating',
  },
  {
    id: 'alt-008',
    severity: 'critical',
    ruleName: 'Sanctions List Match',
    customerName: 'Delta Commodities',
    timestamp: timeOffset(14),
    status: 'open',
  },
  {
    id: 'alt-009',
    severity: 'low',
    ruleName: 'Password Changed',
    customerName: 'Atlantic Ventures',
    timestamp: timeOffset(18),
    status: 'resolved',
  },
  {
    id: 'alt-010',
    severity: 'high',
    ruleName: 'Multiple Beneficiaries in 24h',
    customerName: 'Crown Distributors',
    timestamp: timeOffset(20),
    status: 'investigating',
  },
  {
    id: 'alt-011',
    severity: 'medium',
    ruleName: 'Geographic Anomaly',
    customerName: 'Silverline Brokers',
    timestamp: timeOffset(22),
    status: 'open',
  },
  {
    id: 'alt-012',
    severity: 'low',
    ruleName: 'Profile Information Updated',
    customerName: 'Unity Holdings',
    timestamp: timeOffset(26),
    status: 'resolved',
  },
];

export const filterAlertsBySeverity = (
  alerts: Alert[],
  severity: Severity | 'all'
): Alert[] => {
  if (severity === 'all') return alerts;
  return alerts.filter((alert) => alert.severity === severity);
};

export const filterAlertsByDateRange = (
  alerts: Alert[],
  start: string,
  end: string
): Alert[] => {
  const startDate = new Date(start);
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date(end);
  endDate.setHours(23, 59, 59, 999);
  return alerts.filter((alert) => {
    const timestamp = new Date(alert.timestamp);
    return timestamp >= startDate && timestamp <= endDate;
  });
};
